<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :submission="submission"
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:50px;">
            <div class="col-md-3">
                <form @submit.prevent="savePromoType">
                    <h2>CHOOSE PROMOTION TYPE:</h2>
                    <p>
                        <select v-model="promoType" @change="promoTypeSelected()" required>
                            <option></option>
                            <option value="vb">Volume-Based Promo</option>
                        </select>
                    </p>
                    <br>
                    <p id="promoSelect" style="display:none;">
                        <strong>SELECT PROMOTION:</strong><br>
                        <select v-model="promoTypeAdditional" @change="additionalPromoSelected()" required>
                            <option></option>
                            <option value="gen">General Promo</option>
                            <option value="eb-ss">Early Buy Spring/Summer Seasonal Promo</option>
                            <option value="eb-fw">Early Buy Fall/Winter Seasonal Promo</option>
                        </select>
                    </p>
                    <br>
                    <p id="promoDetail" style="display:none;">
                        <strong>PROMO DETAIL:</strong><br>
                        <select id="promoDetailSelect" v-model="promoDetail">
                            <option></option>
                            <option value="Bisley">Bisley</option>
                        </select>
                    </p>
                    <br />
                    <br />
                    <button class="btn-round-red" type="submit">NEXT STEP ></button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            promoDetail: null,
            promoType: null,
            promoTypeAdditional: null,
            submission: {}
        }
    },
    props: ['ppId'],
    created() {
        axios.get(`/api/getSubmission/${this.ppId}`).then(response => {
            this.submission = response.data;
        });
    },
    methods: {
        savePromoType() {
            let data = {
                id: this.ppId,
                promoDetail: this.promoDetail,
                promoType: this.promoType,
                promoTypeAdditional: this.promoTypeAdditional
            };

            axios.post(`/api/savePromoType`, data).then(response => {
                this.$router.push({
                    name: "PriceWorkflowPromoDetails",
                    params: { ppId: this.ppId }
                });
            });
        },
        promoTypeSelected() {
            if(this.promoType == "vb") {
                $("#promoSelect").show();
            } else {
                $("#promoSelect").hide();
            }
        },
        additionalPromoSelected() {
            if(this.promoTypeAdditional == "gen") {
                $("#promoDetail").show();
                $("#promoDetailSelect").attr('required', '');
            } else {
                $("#promoDetail").hide();
                $("#promoDetailSelect").removeAttr('required', '');
            }
        }
    }
}
</script>

<style scoped>
    #standard-styling {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }
</style>